import React from 'react';
import '../../assets/css/vendor.bundle.css';
import '../../assets/css/style.css';
import '../../assets/css/theme.css';
import Navbar from '../common/NavBar';
import Footer from '../common/Footer';
import { Helmet } from 'react-helmet-async';

const AccountTypes = () => {
	return (
		<div>
			<Helmet>
				<title>Account Types</title>
			</Helmet>
			<div className="site-header header-s1 is-sticky">
				<Navbar />
				{/* Banner/Slider */}
				<div className="page-head section row-vm light has-bg-image">
					<div className="imagebg bg-image-loaded" style={{ backgroundImage: `url(${require('../../assets/images/page-inside-bg.jpg')})` }}>
						<img src={require("../../assets/images/page-bitcoin-bg.jpg")} alt="page-head" />
					</div>
					<div className="container">
						<div className="row text-center">
							<div className="col-md-12">
								<h2>Account Types</h2>
								<div className="page-breadcrumb">
									<ul className="breadcrumb">
										<li><a href="/">Home</a></li>
										<li className="active"><span>Account Types</span></li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* #end Banner/Slider */}
			</div>
			{/* section */}
			<div class="section-pad section">
				<div class="container acc-type-container">
					<div class="section-head">
						<div class="row text-center">
							<div class="col-md-12 col-md-offset-0">
								<h2 class="heading-section">Account Types</h2>
								<p>
									Bringing win-win survival techniques to the platform to guarantee proactive domination.
									At the end of the day, a new reality has emerged from genz,
									and it's on the verge of ushering in unprecedented international account pricing.
								</p>
							</div>
						</div>
					</div>
					<div class="gaps size-3x"></div>
					<div class="row">
						{/* <!-- Basic Card --> */}
						<div class="col-md-2 col-md-offset-0 col-sm-8 col-sm-offset-2 type-card">
							<div class="box-miner box-miner-alt text-block ps-4">
								<div class="box-miner-price ">
									<span class="price-unit">$</span>
									200
								</div>
								<h4 class="box-miner-title text-center ">Basic</h4>
								<ul class="text-left acc-type-list">
									<li><span>Markets - Forex</span></li>
									<li><span>Floating spread</span></li>
									<li><span>Leverage of up to 1:100</span></li>
									<li><span>Standard instructions and training</span></li>
									<li><span>Free signals available</span></li>
									<li><span>Market Alerts Every Day</span></li>
									<li><span>SWAP Free</span></li>
									<li><span>Account Manager</span></li>
									<li><span>24/5 Customer Support</span></li>
									<li><span>Limited Settings</span></li>
								</ul>
								<div class="box-miner-cta ">
									<a href="#" class="btn btn-md btn-alt">Get Started</a>
								</div>
							</div>
						</div>

						{/* <!-- Classic Card --> */}
						<div class="col-md-2 col-md-offset-0 col-sm-8 col-sm-offset-2 type-card">
							<div class="box-miner box-miner-alt text-block">
								<div class="box-miner-price">
									<span class="price-unit">$</span>
									2500
								</div>
								<h4 class="box-miner-title text-center">Classic</h4>
								<ul class="text-left acc-type-list">
									<li><span>Markets - Forex and Commodity</span></li>
									<li><span>Floating spread</span></li>
									<li><span>Leverage of up to 1:200</span></li>
									<li><span>Standard instructions and training</span></li>
									<li><span>Free signals available</span></li>
									<li><span>Market Alerts Every Day</span></li>
									<li><span>SWAP Free</span></li>
									<li><span>Account Manager</span></li>
									<li><span>24/5 Customer Support</span></li>
									<li><span>Limited Settings</span></li>
								</ul>
								<div class="box-miner-cta">
									<a href="#" class="btn btn-md btn-alt">Get Started</a>
								</div>
							</div>
						</div>

						{/* <!-- Advanced Card --> */}
						<div class="col-md-2 col-md-offset-0 col-sm-8 col-sm-offset-2 type-card">
							<div class="box-miner box-miner-alt text-block ps-4">
								<div class="box-miner-price ">
									<span class="price-unit">$</span>
									5000
								</div>
								<h4 class="box-miner-title text-center ">Advanced</h4>
								<ul class="text-left acc-type-list">
									<li><span>Markets - Forex, Commodity and indices</span></li>
									<li><span>Floating spread</span></li>
									<li><span>Leverage up to 1:300</span></li>
									<li><span>Standard instructions and training</span></li>
									<li><span>Average Free Signals</span></li>
									<li><span>Daily Market Alerts</span></li>
									<li><span>SWAP Free</span></li>
									<li><span>Account Manager</span></li>
									<li><span>24/5 Customer Support</span></li>
									<li><span>Limited Settings</span></li>
								</ul>
								<div class="box-miner-cta ">
									<a href="#" class="btn btn-md btn-alt">Get Started</a>
								</div>
							</div>
						</div>

						{/* <!-- Pro Card --> */}
						<div class="col-md-2 col-md-offset-0 col-sm-8 col-sm-offset-2 type-card">
							<div class="box-miner box-miner-alt text-block ps-4">
								<div class="box-miner-price ">
									<span class="price-unit">$</span>
									10000
								</div>
								<h4 class="box-miner-title text-center ">Pro</h4>
								<ul class="text-left acc-type-list">
									<li><span>Markets - Commodity, Indices, Cryptocurrency, Forex</span></li>
									<li><span>Floating spread</span></li>
									<li><span>Leverage up to 1:1000</span></li>
									<li><span>Advanced Training</span></li>
									<li><span>Standard instructions and training</span></li>
									<li><span>Daily Market Alerts</span></li>
									<li><span>SWAP Free</span></li>
									<li><span>Account Manager</span></li>
									<li><span>24/5 Customer Support</span></li>
									<li><span>Unlimited Settings</span></li>
									<li><span>Webinars</span></li>
								</ul>
								<div class="box-miner-cta ">
									<a href="#" class="btn btn-md btn-alt">Get Started</a>
								</div>
							</div>
						</div>

						{/* <!-- VIP Card --> */}
						<div class="col-md-2 col-md-offset-0 col-sm-8 col-sm-offset-2 type-card">
							<div class="box-miner box-miner-alt text-block ps-4">
								<div class="box-miner-price ">
									<span class="price-unit">$</span>
									50000
								</div>
								<h4 class="box-miner-title text-center ">VIP</h4>
								<ul class="text-left acc-type-list">
									<li><span>Markets - Forex, commodity, Indices, Stocks and shares, Cryptocurrency</span></li>
									<li><span>Floating spread</span></li>
									<li><span>Leverage up to 1:1500</span></li>
									<li><span>Expert Training</span></li>
									<li><span>Unlimited Free Signals</span></li>
									<li><span>Daily Market Alerts</span></li>
									<li><span>SWAP Free</span></li>
									<li><span>Account Manager</span></li>
									<li><span>24/5 Customer Support</span></li>
									<li><span>Unlimited Settings</span></li>
									<li><span>Webinars</span></li>
									<li><span>Risk Management</span></li>
									<li><span>Smart Trading</span></li>
								</ul>
								<div class="box-miner-cta ">
									<a href="#" class="btn btn-md btn-alt">Get Started</a>
								</div>
							</div>
						</div>

						{/* <!-- Investor Card --> */}
						<div class="col-md-2 col-md-offset-0 col-sm-8 col-sm-offset-2 type-card">
							<div class="box-miner box-miner-alt text-block ps-4">
								<div class="box-miner-price ">
									<span class="price-unit">$</span>
									∞
								</div>
								<h4 class="box-miner-title text-center ">Investor</h4>
								<ul class="text-left acc-type-list">
									<li><span>Markets - All Markets</span></li>
									<li><span>Floating spread</span></li>
									<li><span>Leverage up to 1:2000</span></li>
									<li><span>Professional Training</span></li>
									<li><span>Unlimited Free Signals</span></li>
									<li><span>Daily Market Alerts</span></li>
									<li><span>SWAP Free</span></li>
									<li><span>Fund Manager</span></li>
									<li><span>24/5 Customer Support</span></li>
									<li><span>Unlimited Settings</span></li>
									<li><span>Webinars & Meetings</span></li>
									<li><span>Risk Management</span></li>
									<li><span>Smart Trading</span></li>
									<li><span>PT Conditions</span></li>
								</ul>
								<div class="box-miner-cta ">
									<a href="#" class="btn btn-md btn-alt">Get Started</a>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>{/*End section */}

			<Footer />

		</div>
	);
};

export default AccountTypes;